var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmericanFootball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICON_American_Football") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON_American_Football",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_football_582_000000",
    transform: "translate(25.000000, 24.535050) rotate(-315.000000) translate(-25.000000, -24.535050) translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.172,6.5465 C2.4298,9.26525 0,12.3005 0,14.535 C0,16.7695 2.4297,19.8045 6.172,22.5215 L6.172,6.5465 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.828,6.5465 L43.828,22.521 C47.5702,19.80225 50,16.769 50,14.5345 C50,12.3 47.5703,9.265 43.828,6.546 L43.828,6.5465 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,0 C19.719,0 14.289,1.7871 9.844,4.22655 L9.844,24.84355 C14.28735,27.28495 19.717,29.0701 25,29.0701 C30.281,29.0701 35.711,27.28495 40.156,24.84355 L40.156,4.22655 C35.7107,1.7871 30.281,0 25,0 Z M33.3165,17.168 L31.7696,17.168 L31.7696,15.3086 L29.3536,15.3086 L29.3536,17.168 L27.8067,17.168 L27.8067,15.3086 L25.3907,15.3086 L25.3907,17.168 L23.8438,17.168 L23.8438,15.3086 L21.4278,15.3086 L21.4278,17.168 L19.8809,17.168 L19.8809,15.3086 L17.4649,15.3086 L17.4649,17.168 L15.918,17.168 L15.918,11.9025 L17.4649,11.9025 L17.4649,13.7619 L19.8809,13.7619 L19.8809,11.9025 L21.4278,11.9025 L21.4278,13.7619 L23.8438,13.7619 L23.8438,11.9025 L25.3907,11.9025 L25.3907,13.7619 L27.8067,13.7619 L27.8067,11.9025 L29.3536,11.9025 L29.3536,13.7619 L31.7696,13.7619 L31.7696,11.9025 L33.3165,11.9025 L33.3165,17.168 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanFootball);
export default ForwardRef;